import React from 'react';
import cx from 'classnames';
import styles from './Amount.module.scss';
import AmountProps from './Amount.types';
import { formatAmount } from '../../utils/textFormatting';

const Amount = ({
  children,
  locale,
  currency,
  currencyDisplay,
  maximumSignificantDigits,
  round = false,
  noDecimal = false,
  className,
  dataCy = 'amount',
}: AmountProps) => (
  <span className={cx(styles.amount, className)} data-amount={children} data-cy={dataCy}>
    {formatAmount({
      children,
      locale,
      currency,
      currencyDisplay,
      maximumSignificantDigits,
      round,
      noDecimal,
    })}
  </span>
);

export default Amount;
